<template>
  <div :class="[$style.spinner, $style[props.size], $style[props.type]]">
    <div :class="$style.arc" />
    <div :class="$style.arcReverse" />
  </div>
</template>

<script setup>
import {
  BUTTON_SPINNER_SIZES,
  BUTTON_SPINNER_TYPES,
} from '@/shared/components/UI/Button/button';

const props = defineProps({
  size: {
    type: String,
    default: BUTTON_SPINNER_SIZES.MEDIUM,
  },
  type: {
    type: String,
    default: BUTTON_SPINNER_TYPES.PRIMARY,
  },
});
</script>

<style lang="scss" module>
.spinner {
  position: relative;

  .arc,
  .arcReverse {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 2px solid transparent;
    border-radius: 50%;
    box-sizing: border-box;
  }

  .arc {
    animation: spin 1s linear infinite;
  }

  .arcReverse {
    animation: spinReverse 1s linear infinite;
  }

  &.small {
    width: 15px;
    height: 15px;
  }

  &.medium {
    width: 18px;
    height: 18px;
  }

  &.primary {
    .arc {
      border-top-color: $button-text-invert;
    }

    .arcReverse {
      border-bottom-color: $button-text-invert;
    }
  }

  &.secondary {
    .arc {
      border-top-color: $button-text-default;
    }

    .arcReverse {
      border-bottom-color: $button-text-default;
    }
  }

  &.outline {
    .arc {
      border-top-color: $button-text-default;
    }

    .arcReverse {
      border-bottom-color: $button-text-default;
    }
  }

  &.text {
    .arc {
      border-top-color: $button-text-hover;
    }

    .arcReverse {
      border-bottom-color: $button-text-hover;
    }
  }

  &.error {
    .arc {
      border-top-color: $button-text-error;
    }

    .arcReverse {
      border-bottom-color: $button-text-error;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinReverse {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
